<template>
  <div>
    <b-table
      :id="id"
      ref="reportListTableRef"
      :bordered="true"
      :items="listReport"
      :fields="reportFields"
      class="table-striped mt-1"
      :primary-key="'id'"
      role="grid"
      aria-describedby="user-list-page-info"
    >
      <template v-slot:cell(stt)="data">
        <span>{{data.item.stt}}</span>
      </template>
      <template v-slot:cell(title)="data">
        <div class="flex align-items-center">
          <span v-html="data.item.space"/>
          <span class="ml-2">{{ data.item.title }}</span>
        </div>
      </template>
      <template v-slot:cell(vnd)="data">
        <span :style="applyNumberStyle(data.item.total_vnd)">{{data.item.total_vnd}}</span>
      </template>

      <template v-slot:cell(usd)="data">
        <span :style="applyNumberStyle(data.item.total_usd)">{{data.item.total_usd}}</span>
      </template>

      <template v-slot:custom-foot>
        <tr>
          <td></td>
          <td align="right">TỔNG</td>
          <td align="right" v-if="detailReport.summary_success_report" :style="applyNumberStyle(detailReport.summary_success_report['debtor']['vnd'])">{{detailReport.summary_success_report['debtor']['vnd']}}</td>
          <td align="right" v-if="detailReport.summary_success_report" :style="applyNumberStyle(detailReport.summary_success_report['debtor']['usd'])">{{detailReport.summary_success_report['debtor']['usd']}}</td>
        </tr>
      </template>
    </b-table>
  </div>
</template>

<script>
import { findash } from '../../../../config/pluginInit'
import _ from 'lodash'
import { applyNumberStyle, formatNumber, formatNumberByLocale } from '@/utils'
import { mapGetters } from 'vuex'

function isEmptyData (ele) {
  return (ele.total_vnd === '0' && ele.total_usd === '0') || (ele.total_vnd === 0 && ele.total_usd === 0)
}

export default {
  name: 'Debtor',
  async mounted () {
    findash.index()
  },
  created () {
  },
  props: [ 'id' ],
  data () {
    return {
      reportFields: [
        {
          key: 'stt',
          label: '#',
          class: 'text-center'
        },
        {
          key: 'title',
          label: 'THÀNH VIÊN',
          class: 'text-left'
        },
        {
          key: 'vnd',
          label: 'VND',
          class: 'text-right'
        },
        {
          key: 'usd',
          label: 'USD',
          class: 'text-right'
        }
      ],
      listReport: [],
      stt: 1,
      custom_id: 0,
      parseDataArr: null
    }
  },
  computed: {
    ...mapGetters({
      'detailReport': 'Report/detailReportState'
    })
  },
  watch: {
    detailReport: function (newVal, oldVal) {
      if (newVal !== oldVal && this.detailReport && this.detailReport.summary_success_report) {
        this.parseData()
      }
    }
  },
  methods: {
    skeletorData (data, rootLevel) {
      _.map(data, (e) => {
        let _stt = ''

        if (rootLevel) {
          _stt = this.stt++
        }

        return _.extend(e, { custom_id: this.custom_id++, toggle: false, space: '', level: 1, stt: _stt })
      })

      return data
    },
    applyNumberStyle (number) {
      return applyNumberStyle(number)
    },
    applyNumberFormat (number, locale) {
      return formatNumberByLocale(number, locale)
    },
    parseData () {
      let parseDataReturn = null

      parseDataReturn = _.compact(_.map(this.detailReport.summary_success_report['debtor']['debtors'], (level0) => {
        if (isEmptyData(level0)) return
        return {
          'id': level0.id,
          'title': level0.name,
          'total_vnd': formatNumber(level0.total_vnd),
          'total_usd': formatNumber(level0.total_usd)
        }
      }))

      this.listReport = this.skeletorData(parseDataReturn, true)

      // reset
      this.stt = 1
    }
  }
}
</script>
